module.exports = __webpack_public_path__ + "d3fff8a8a503415e2aa33ed80e5fe3af.svg";